<template>
    <v-card elevation="5" class="full-height">

        <v-layout column fill-height class="container-of-fullheight-element">

            <v-toolbar color="primary" dark class="elevation-1">

                <v-icon>insert_drive_file</v-icon>

                <v-toolbar-title>{{$t('Files')}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn flat icon @click="settings=!settings">
                    <v-icon>apps</v-icon>
                </v-btn>

            </v-toolbar>

            <v-expansion-panel style="display: block;">
                <v-expansion-panel-content :value="settings">
                    <v-toolbar color="white" light class="elevation-1 content-height-auto">
                        <v-layout column align-center justify-center>

                            <v-layout align-center justify-space-between class="fill-width" wrap>

                                <v-flex xs6>
                                    <v-overflow-btn class="ma-2" dense solo hide-details
                                                    :items="length_options" cache-items
                                                    :label="$t('Number of files')"
                                                    return-object
                                                    v-model="length_option"
                                                    target="#dropdown-example"
                                    ></v-overflow-btn>
                                </v-flex>

                                <v-flex xs6>
                                    <v-overflow-btn class="ma-2" dense solo hide-details
                                                    :items="sort_options"
                                                    return-object
                                                    :label="$t('Sort by')"
                                                    v-model="sort_option"
                                                    target="#dropdown-example"
                                    ></v-overflow-btn>
                                </v-flex>

                                <v-flex xs6>
                                    <v-btn-toggle v-model="owner_option" light mandatory class="mx-2 elevation-1" style="display: flex; justify-content: space-around; height: 48px;">
                                        <v-btn flat class="full-height">
                                            <span>{{$t('All Files')}}</span>
                                        </v-btn>
                                        <v-btn flat class="full-height">
                                            <span>{{$t('My Files')}}</span>
                                        </v-btn>
                                        <v-btn flat class="full-height">
                                            <span>{{$t('Shared to me')}}</span>
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-flex>

                                <v-flex xs6>
                                    <v-text-field
                                            :placeholder="$t('Search...')"
                                            single-line
                                            append-icon="search"
                                            hide-details solo
                                            clearable class="ma-2"
                                            v-model="search"
                                    ></v-text-field>
                                </v-flex>

                            </v-layout>

                        </v-layout>
                    </v-toolbar>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-container v-if="loading" fluid class="pa-0">
                <v-progress-linear   height="10"
                                     color="primary"
                                     indeterminate
                ></v-progress-linear>
            </v-container>

            <v-container class="pa-0 fullheight-element" v-if="!loading">

                <p v-if="!files.length" class="my-3">{{$t('No files found.')}}</p>

                <v-list v-if="files.length" two-line subheader>

                    <v-list-tile class="list-height-auto"
                            v-for="file in files"
                            :key="file.hash"
                            avatar
                            @click="goToFile(file.type, file.hash)"
                    >
                        <v-list-tile-avatar>
                            <FileIcon round :mimetype="file.mimetype"></FileIcon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>


                            <v-container v-if="file.type === 'pending'" fluid class="no-padding">
                                <v-layout row wrap>
                                    <v-flex md12 class="pr-3">
                                        <v-layout column justify-center fill-height>
                                            <v-list-tile-title>{{ file.name}}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ $t('Uploading file...' )}}</v-list-tile-sub-title>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>


                            <v-container v-if="file.type === 'tracker'" fluid class="no-padding">
                                <v-layout row wrap>

                                    <v-flex md5 class="pr-3">
                                        <v-layout column justify-center fill-height>
                                            <v-list-tile-title>{{ file.name}}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ $moment(file.created).format('DD-MM-YYYY HH:mm') }}</v-list-tile-sub-title>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex md4>
                                        <v-layout v-if="file.users.length < 4" column justify-center fill-height>
                                            <div v-for="user in file.users" :key="user.address" v-if="user.address !== file.owner.address">
                                                <v-layout v-if="user.name" row fill-height>
                                                    <v-icon class="mr-1">person</v-icon>
                                                    <span class="v-list__tile__title">{{user.name}}</span>
                                                </v-layout>
                                                <v-layout v-else row fill-height>
                                                    <v-icon class="mr-1">email</v-icon>
                                                    <span class="v-list__tile__title">{{user.email}}</span>
                                                </v-layout>
                                            </div>
                                        </v-layout>

                                        <v-layout v-else column justify-center fill-height>
                                            <div>
                                                <v-btn round outline  @click="clickUsers($event, file.users)">
                                                    <v-icon class="mr-1">people</v-icon>
                                                    <span>{{$t('list.users', {count: file.users.length-1})}}</span>
                                                </v-btn>
                                            </div>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex md3 class="pl-3">
                                        <v-layout column fill-height style="max-width: 130px;" class="ml-auto">
                                            <v-chip color="primary" text-color="white">
                                                <v-avatar class="primary darken-4">{{ (counters[file.hash]) ? counters[file.hash].view : '...' }}</v-avatar>
                                                {{$t('Views')}}
                                            </v-chip>
                                            <v-chip v-if="!counters[file.hash] || counters[file.hash].download > -1" color="green" text-color="white">
                                                <v-avatar class="green darken-4">{{ (counters[file.hash]) ? counters[file.hash].download : '...' }}</v-avatar>
                                                {{$t('Downloads')}}
                                            </v-chip>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>


                            <v-container v-if="file.type === 'viewer'" fluid class="no-padding">
                                <v-layout row wrap>
                                    <v-flex md12 class="pr-3">
                                        <v-layout column justify-center fill-height>
                                            <v-list-tile-title>{{ file.name}}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ $moment(file.created).format('DD-MM-YYYY HH:mm') }}</v-list-tile-sub-title>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>


                        </v-list-tile-content>

                    </v-list-tile>

                </v-list>
            </v-container>

            <v-footer v-if="!loading && files.length" color="white" light class="elevation-1" style="min-height: 51px; margin-top: 1px;">
                <v-layout align-center justify-space-between>

                    <span class="ma-2">{{$t('list.display', {start: Math.max(1, this.limit * (this.page-1)), end: Math.min(this.limit * this.page, this.filesLength), max: this.filesLength})}}</span>

                    <v-pagination class="ma-2"
                            v-model="page"
                            :length="filesPages"
                            :total-visible="7"
                            light circle color="primary"
                    ></v-pagination>
                </v-layout>
            </v-footer>

        </v-layout>

    </v-card>
</template>

<script>

    import LocalRepository from '../repositories/LocalRepository';
    import FilesRepository from '../repositories/FilesRepository';
    import { VExpansionPanel, VExpansionPanelContent, VBtnToggle, VOverflowBtn, VPagination, VFooter, VTextField, VChip, VAvatar, VProgressLinear, VContainer, VLayout, VFlex, VCard, VToolbar, VToolbarTitle, VSpacer, VBtn, VIcon, VList, VListTile, VListTileAvatar, VListTileContent, VListTileTitle, VListTileSubTitle   } from 'vuetify/lib'
    import FileIcon from "./FileIcon";

    export default {
        name: 'MyFilesBox',
        components: {
            VExpansionPanel, VExpansionPanelContent, VBtnToggle, VOverflowBtn, VPagination, VFooter, VTextField, FileIcon, VChip, VAvatar, VProgressLinear, VContainer, VLayout, VFlex, VCard, VToolbar, VToolbarTitle, VSpacer, VBtn, VIcon, VList, VListTile, VListTileAvatar, VListTileContent, VListTileTitle, VListTileSubTitle
        },
        created() {
            this.loadCurrentOptions();
            this.fetch();
            this.listenSocket();
        },
        data () {
            return {
                // Loading
                loading: true,
                users: false,

                // Settings visible
                settings: false,

                // Files list
                files: [ ],
                filesLength: 0,

                // Type of files
                owner_option: 0,
                owner: null,

                // Sort Options
                sort: 'date',
                sort_option: null,
                sort_options: [
                    { text: 'Sort by created date', value: 'date'},
                    { text: 'Sort alphabetically', value: 'name' },
                ],

                // Length Options
                length_option: null,
                length_options: [
                    { text: '5 files per page', value: 5 },
                    { text: '10 files per page', value: 10 },
                    { text: '25 files per page', value: 25 },
                    { text: '50 files per page', value: 50 },
                ],

                // Limit and offset
                page: 1,
                limit: 10,

                // File counters list
                counters: [ ],

                // Search input
                search: "",

            }
        },
        watch: {
            search: function() {
                this.fetch();
            },
            owner_option: function() {
                switch (this.owner_option) {
                    case 0:
                        this.owner = null;
                        break;
                    case 1:
                        this.owner = true;
                        break;
                    case 2:
                        this.owner = false;
                        break;
                }
                this.fetch();
            },
            page: function() {
                this.fetch();
            },
            sort_option: function() {
                if (this.sort_option && this.sort_option.value) {
                    this.sort = this.sort_option.value;
                    this.fetch();
                }
            },
            length_option: function() {
                if (this.length_option && this.length_option.value) {
                    this.limit = this.length_option.value;
                    this.fetch();
                }
            }
        },
        methods: {
            fetch(doLoading = true) {
                if (doLoading) {
                    this.loading = true;
                    this.files = [];
                }
                this.saveCurrentOptions();
                FilesRepository.getMyFiles(this.search, this.page, this.limit, this.sort, this.owner)
                    .then((response) => {
                        this.files = response.data.files;
                        this.filesLength = response.data.length;
                        this.filesPages = response.data.pages;
                        this.loading = false;
                    })
                    .catch((error) => {
                        if (!error.cancelled) {
                            this.loading = false;
                            this.$root.$emit('show-modal', {
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: 'error'
                            });
                        }
                    });
            },

            saveCurrentOptions() {
                LocalRepository.set('list_options', {limit: this.limit, sort: this.sort, owner: this.owner})
            },

            loadCurrentOptions() {
                if (LocalRepository.has('list_options')) {
                    let list_options = LocalRepository.get('list_options');
                    this.limit = list_options.limit;
                    this.sort = list_options.sort;
                    this.owner = list_options.owner;
                    this.length_option = this.searchByValue(this.length_options, this.limit);
                    this.sort_option = this.searchByValue(this.sort_options, this.sort);
                    this.owner_option = this.parseOwnerToNumber(this.owner);
                }
            },

            searchByValue(items, value) {
                for (let item of items) {
                    if (item.value === value) {
                        return item;
                    }
                }
                return null;
            },

            parseOwnerToNumber(owner) {
                if (owner === null) return 0;
                if (owner === true) return 1;
                if (owner === false) return 2;
            },

            goToFile(type, hash){
                if (type === 'tracker') {
                    this.goToTracker(hash);
                } else if (type === 'viewer') {
                    this.goToViewer(hash);
                }
            },

            goToTracker(hash) {
                this.$router.push({name: 'tracker-logged', params: {hash: hash}});
            },

            goToViewer(hash) {
                this.$router.push({name: 'viewer-logged', params: {hash: hash}});
            },

            clickUsers(event, users) {
                let message = "";
                for (let user of users) {
                    if (message.length > 0) message += "\n";
                    message += user.name ? user.name : user.email;
                }
                this.$root.$emit('show-modal', {
                    title: this.$t('Users'),
                    message: message,
                    type: 'info'
                });
                event.stopPropagation();
            },

            listenSocket() {

                this.sockets.subscribe('UPDATE_FILES', (data) => {
                    this.fetch(false);
                });

                this.sockets.subscribe('UPDATE_COUNTERS', (data) => {
                    if (data.hash) {
                        this.counters[data.hash] = data;
                    }
                    this.$forceUpdate();

                });

            }
        },

        sockets: {

            UPDATE_FILES: function () {
                this.fetch(false);
            },

            UPDATE_COUNTERS: function (params) {
                let data = params[0];
                if (data.hash) {
                    this.counters[data.hash] = data;
                }
                this.$forceUpdate();
            }

        },

    }
</script>

<style lang="scss">
    .list-height-auto > .v-list__tile {
        height: auto!important;
        min-height: 80px;
    }

    .v-pagination button {
        margin-top:0; margin-bottom:0;
    }

    .content-height-auto .v-toolbar__content {
        height: auto!important;

    }
</style>